/** Store / brand mark in the designer chrome. Falls back to “OX” tile. */
export function BrandLogo({
  url,
  href,
  className = '',
}: {
  url?: string | null;
  /** When set, logo links out (e.g. store home). */
  href?: string | null;
  className?: string;
}) {
  const src = url?.trim() || '';
  const link = href?.trim() || '';
  const body = src ? (
    <img src={src} alt="" />
  ) : (
    <>OX</>
  );
  const classes = [
    className,
    'ox-brand-logo',
    src ? 'ox-brand-logo--image' : 'ox-brand-logo--fallback',
    link ? 'ox-brand-logo--link' : '',
  ]
    .filter(Boolean)
    .join(' ');

  if (link) {
    return (
      <a className={classes} href={link} aria-label="Ir a la tienda" title="Ir a la tienda">
        {body}
      </a>
    );
  }

  return (
    <div className={classes} aria-hidden>
      {body}
    </div>
  );
}
